import { Component, OnInit } from '@angular/core';

import { AuthenticationService } from '../../services/core/authentication.service';
import { AppService } from '../../services/app.service';
import { ApiConnectionService } from '../../services/core/api-connection.service';
import { CollectionManagerService } from '../../services/core/collection-manager.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfigService } from '../../services/core/config.service';

import { DomSanitizer } from '@angular/platform-browser';

@Component({
	selector: 'app-index',
	templateUrl: './index.component.html',
	styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {
	sections: any = [];

	currentUser;
	currentOrganisation: any = {};
	organisations: any = [];

	topSections: any = [];
	bottomSections: any = [];
	highlight: any = '';
	introText: any = '';
	introImage: string = '';
	cdnUrl = ''
	systemTitle = ''
	systemSlogan = ''
	systemKey = ''
	salesWebsite = ''
	banner = null;
	sectionIntro = ''
	topSectionsIsLoaded = false;
	frontType = 'DEfAULT';
	frontTypeChapter;
	activeChapterIds = {};
	checkLicense = false;
	showDropdown = false;
  
	youtubeEmbedSafeURL = null;

	highlightLessons: any = [];

	youtubeBannerCache = null;

	constructor(
		public appService: AppService,
		public apiConnectionService: ApiConnectionService,
		public authenticationService: AuthenticationService,
		public collectionManager: CollectionManagerService,
		private ngxLoader: NgxUiLoaderService,
		private dom: DomSanitizer,
		private configService: ConfigService
	) {
		let self = this;

		this.cdnUrl = configService.get('cdn_url');
		this.sectionIntro = configService.get('intro_text');
		this.systemTitle = configService.get('title');
		this.systemSlogan = configService.get('slogan');
		this.systemKey = configService.get('system_key');
		this.salesWebsite = configService.get('sales_website');

		self.authenticationService.data.subscribe(data => {
			if (Object.keys(data).length) {
				self.currentUser = data;
				self.frontType = this.currentUser['organisationFrontType'];

				if (self.currentUser.role === 'ADMIN') {
					self.getOrganisations();
				}

				if (self.currentUser.role === 'ADMIN' || self.currentUser.role === 'TEACHER') {
					self.banner = configService.get('banner_teacher');
				} else {
					self.banner = configService.get('banner_student');
				}

				self.setChapterContent();
				self.setSections();
				self.setContent();
			} else {
				self.currentUser = false;
				self.setSections();
				self.setContent();
			}
		});
		
		self.appService.getCurrentOrganisation();
		self.appService.currentOrganisation.subscribe(data => {
			self.currentOrganisation = data;
			self.getOrganisations();
		});
	}

	openURL(url) {
		if (!url || url.length < 1)
		{
			return;
		}
		window.location.href = url;
	}

	getMaxLessonsPerCarouselItem() {
		let maxLessonsPerCarouselItem
		const screenWidth = window.innerWidth
		if ( screenWidth >= 992 ) {
			maxLessonsPerCarouselItem = 3
		} else if ( screenWidth >= 576 ) {
			maxLessonsPerCarouselItem = 2
		} else {
			maxLessonsPerCarouselItem = 1
		}
		 return maxLessonsPerCarouselItem
	}

	splitCarouselAtIndex(index) {
		const maxLessonsPerCarouselItem = this.getMaxLessonsPerCarouselItem()

		if (!this.highlightLessons || this.highlightLessons.length  < 1)
		{
			return [];
		}
		if (index < 0 || index >= Math.ceil(this.highlightLessons.length / maxLessonsPerCarouselItem)) {
			return "Invalid index";
		}
	
		const startIndex = index * maxLessonsPerCarouselItem;
		const endIndex = Math.min(startIndex + maxLessonsPerCarouselItem, this.highlightLessons.length);
		return this.highlightLessons.slice(startIndex, endIndex);
	}

	getCarouselSize() {
		const maxLessonsPerCarouselItem = this.getMaxLessonsPerCarouselItem()

		if (!this.highlightLessons)
		{
			return 1;
		}
		if ((this.highlightLessons.length / maxLessonsPerCarouselItem) < 1)
		{
			return 1;
		}
		return Math.ceil(this.highlightLessons.length / maxLessonsPerCarouselItem);
	}

	toggleDropdown() {
		if (this.showDropdown === true) {
			this.showDropdown = false;
		} else {
			this.showDropdown = true;
		}
	}

	getOrganisations() {
		let self = this;
		self.apiConnectionService.read('organisations').then(function (response) {
			self.organisations = response;
		});
	}

	showLogin() {
		this.appService.showLoginModal();
	}

	ngOnInit(): void {
		this.appService.navActive();
		this.appService.setPageTitle('');
		this.appService.setPageDescription('');

		let self = this;

		self.authenticationService.getCurrentUser();
		self.appService.setDefaultAuthor();
		self.appService.setDefaultMeta();
		this.introImage = this.configService.get('intro_image_url');

		self.setHighlightLessons();
	}

	setHighlightLessons () {
		let self = this;
		self.apiConnectionService.read('index/highlights').then((response) => {
			self.highlightLessons = response;
		});
	}

	setChapterContent() {
		let self = this;

		self.ngxLoader.start();
		self.apiConnectionService.read('pages/front').then((response) => {
			self.frontTypeChapter = response;
			self.ngxLoader.stop();
		});
	}

	setContent() {
		let self = this;

		self.ngxLoader.start();
		self.apiConnectionService.read('pages/home').then((response) => {
			self.highlight = self.dom.bypassSecurityTrustHtml(response['highlight']);
			self.introText = self.dom.bypassSecurityTrustHtml(response['introText']);
			self.ngxLoader.stop();
		});
	}

	setSections() {
		let self = this;

		if (self.currentUser === false) {
			this.topSections = this.configService.get('top_sections');
			this.bottomSections = this.configService.get('bottom_sections');
			return;
		} else if (self.currentUser['role'] === 'TEACHER' || self.currentUser['role'] === 'ADMIN') {
			this.topSections = this.configService.get('top_sections');
			this.bottomSections = this.configService.get('bottom_sections');

			self.ngxLoader.start();
			self.apiConnectionService.read('sections').then((response) => {
				let collection: any = response;

				for (let key in collection) {
					for (let chapterKey in collection[key]['chapters']) {
						self.activeChapterIds[collection[key]['chapters'][chapterKey]['id']] = true;
					}
				}
				self.checkLicense = true;
				self.topSectionsIsLoaded = true;
				self.ngxLoader.stop();
			});
		} else {
			self.ngxLoader.start();
			self.apiConnectionService.read('sections').then((response) => {
				self.topSections = [];
				self.bottomSections = [];

				let collection: any = response;

				for (let key in collection) {
					if (collection[key]['homeTop'] == 1) {
						self.topSections.push(collection[key]);
					}
					if (collection[key]['homeBottom'] == 1) {
						self.bottomSections.push(collection[key]);
					}
				}

				self.topSectionsIsLoaded = true;
				self.ngxLoader.stop();
			});
		}
	}

	text(lesson) {
		return this.dom.bypassSecurityTrustHtml(lesson);
	}

	changeOrganisation(value) {
		let self = this;
		this.apiConnectionService.read('users/setCurrentOrganisationId/' + value + '').then(function (response) {
			window.location.reload();
		});
	}

	searchOrganisation(event) {
		let keyword = event.target.value;
		keyword = keyword.toLowerCase();

		for (let key in this.organisations) {
			let searchString = JSON.stringify(this.organisations[key]);
			searchString = searchString.toLowerCase();

			if (searchString.indexOf(keyword) !== -1) {
				this.organisations[key].hidden = false;
			} else {
				this.organisations[key].hidden = true;
			}
		}
	}

	embed(url) {
		if(this.youtubeBannerCache == null) {
			this.youtubeBannerCache = this.dom.bypassSecurityTrustResourceUrl(url);;
		}
		return this.youtubeBannerCache;
	}
}
